module.exports = __webpack_public_path__ + "media/images/tutorial_body_pc1-01-866f8e7c9e19d8065317f9fa3c7ea4dc.png";